import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createPipelineActions } from './actions';
import { PipelineActions, PipelineState } from './types';

export const usePipelineStore = create<PipelineState & PipelineActions>()(
    immer((set, get, store) => ({
        pipelines: [],
        loading: false,
        selectedPipeline: null,
        loadingPipeline: false,
        error: undefined,
        ...createPipelineActions(set, get, store),
    })),
);
